import React, { useEffect, useRef, useState } from "react";
import Desmos from "desmos";
import Draggable from "react-draggable";

const Calculator = ({ show, onClose }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const calculatorRef = useRef(null);

  useEffect(() => {
    let calculator;
    if (calculatorRef.current) {
      calculatorRef.current.style.width = isExpanded ? "600px" : "350px";
      calculatorRef.current.style.height = "500px";
      calculator = Desmos.GraphingCalculator(calculatorRef.current);
    }
    return () => calculator && calculator.destroy();
  }, [show, isExpanded]);

  if (!show) return null;

  const handleExpandClick = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <Draggable handle=".calculator-drag-handle">
      <div
        className="calculator-container"
        style={{ position: "fixed", top: "15%", left: "10%", zIndex: 100 }}
      >
        <div ref={calculatorRef} />
        <header
          className="calculator-drag-handle"
          style={{
            width: "100%",
            position: "absolute",
            top: "-27px",
            right: "0",
            backgroundColor: "black",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "0 5px",
            color: "white",
            cursor: "move",
          }}
        >
          <h6 style={{ margin: 0 }}>Calculator</h6>
          <div
            style={{
              flexGrow: 1,
              display: "flex",
              justifyContent: "center",
              marginLeft: "35px",
            }}
          >
            <div className="handle">
              <i className="fas fa-arrows-alt" style={{ color: "white" }}></i>
            </div>
          </div>
          <div>
            <button
              onClick={handleExpandClick}
              style={{
                background: "none",
                border: "none",
                color: "white",
                // marginRight: "5px",
              }}
            >
              <i className="fas fa-expand-arrows-alt"></i> Expand
            </button>
            <button
              onClick={onClose}
              style={{ background: "none", border: "none", color: "white" }}
            >
              <i className="fas fa-times"></i>
            </button>
          </div>
        </header>
      </div>
    </Draggable>
  );
};

export default Calculator;
